import clsx from 'clsx';
import * as React from 'react';
import {
    ColorThumb as RACColorThumb,
    type ColorThumbProps as RACColorThumbProps,
} from 'react-aria-components';

export type ColorThumbProps = RACColorThumbProps;

/**
 * A color thumb is a draggable element that allows users to adjust a color value.
 */
export const ColorThumb = React.forwardRef(function ColorThumb(
    props: ColorThumbProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACColorThumb
            ref={ref}
            {...props}
            className={clsx(
                'peer/color-thumb',
                'group-[]/color-slider:h-full group-[]/color-slider:w-3',
                'group-[]/color-slider:data-[focus-visible]:w-4',
                'size-4 rounded-full border-2 border-white shadow-[0_0_0_1px_black,_inset_0_0_0_1px_black] data-[focus-visible]:size-6',
                props.className
            )}
        />
    );
});
